<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VWseTp/tc-custom/9780547523613.jpg?1701061179714" alt="This image is the cover for the book Grace of Everyday Saints"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Grace of Everyday Saints
      </h1>
      <p class="bookDescription body article font2">
        <b>Including interviews with dozens of parishioners, this story of the battle for St. Brigid is “a dramatic David vs. Goliath account of a church under siege” (<i>Kirkus Reviews</i>).</b><br/><br/>St. Brigid Church was one of San Francisco’s great landmarks in the early 1990s. The church itself had weathered depressions and natural disasters, epic earthquakes and a massive fire. Its loyal congregation was active, vibrant, and growing. But in 1993, without warning, the Catholic archdiocese mysteriously ordered its doors to be closed.<br/><br/><i>The Grace of Everyday Saints</i> is the story of how a ragtag group of believers came together in a crusade to save their church. What they discovered would be devastating: that around the country, parishes like theirs were threatened by the higher echelons of the Church, all to hide a terrible secret. Soon there were near-daily headlines that shocked the world. But still this unlikely group of heroes—led by a renegade lawyer, a reformed Catholic, and an antiestablishment priest—continued to meet weekly, to fight, to prove that their beloved St. Brigid was worth saving.<br/><br/>A dramatic narrative that takes readers from the streets of San Francisco to the halls of the Vatican, <i>The Grace of Everyday Saints</i> is about injustice and betrayal, redemption and grace.<br/><br/>“A gripping story.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Julian Guthrie
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (hmhbooks.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3c4c644b